import React from 'react'
import { Route } from 'react-router'
import RedirectToPlural from '@/modules/layout/util/redirectToPlural'

const ArticleList = React.lazy(() => import('./components/list/article-list'))
const ArticleDetails = React.lazy(() => import('./components/detail/article-detail'))
const ArticleEdit = React.lazy(() => import('./components/edit/article-edit'))

const articleRoutes = (
  <>
    <Route path='article/*' element={<RedirectToPlural />} />
    <Route path='articles' Component={ArticleList} handle={{ title: 'Artikel', options: { noBackgroundColor: true } }} />
    <Route path='articles/:id' Component={ArticleDetails} handle={{ title: 'Artikel-Details' }} />
    <Route path='articles/edit/:id/:hash?' Component={ArticleEdit} handle={{ title: 'Artikel bearbeiten' }} />
    <Route path='articles/new' Component={ArticleEdit} handle={{ title: 'Neuen Artikel erstellen' }} />
  </>
)

export default articleRoutes
